import React, { useEffect, useState } from 'react';
import './moneyFromReferralsSection.scss';
import { ReactComponent as RefRobotLine } from "./icons/RefRobotLine.svg";
import { ReactComponent as RefScheme } from "./icons/RefScheme.svg";
import { ReactComponent as RefSchemeAdaptive } from "./icons/RefSchemeAdaptive.svg";
import { ReactComponent as FirstShineIcon } from "./icons/FirstShineIcon.svg";
import { ReactComponent as SecondShineIcon } from "./icons/SecondShineIcon.svg";

const MoneyFromReferralsSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="moneyFromReferrals">
			<div className="moneyFromReferrals__content">
				<div className="moneyFromReferrals__content_data">
					<div className="moneyFromReferrals__content_data_title">
						<h3>Earn money from referrals</h3>
						<span>Get <span className="colored up">up</span> to <span className="colored percent">35%</span> of your referrals' commission with our <span className="colored ref">5-tier referral</span> program on the best terms in spice</span>
					</div>
					<div className="moneyFromReferrals__content_data_discount">
						<FirstShineIcon />
						<SecondShineIcon />
						<h4>10% discount for those who register through a referral link</h4>
					</div>
				</div>
				<div className="moneyFromReferrals__content_scheme">
					<div className="moneyFromReferrals__content_scheme_robot">
						<div className="moneyFromReferrals__content_scheme_robot_bg">
							<RefRobotLine />
						</div>
					</div>
					{
						width > 767 ? (
							<RefScheme />
						) : (
							<RefSchemeAdaptive />
						)
					}
				</div>
			</div>
		</div>
	);
};

export default MoneyFromReferralsSection;